import { render, staticRenderFns } from "./BoardContext.vue?vue&type=template&id=40324094"
import script from "./BoardContext.vue?vue&type=script&lang=js"
export * from "./BoardContext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports